import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/construction-software/construction-banner.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner real-estate-banner restaurant-banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Construction Software Development Company
              </h1>
              <span>
                Building Success with{" "}
                <span style={{ color: "#f47a14" }}>Tailored Construction</span>{" "}
                Solutions
              </span>
              <p style={{ marginTop: "10px" }}>
                From budget overruns to operational bottlenecks, construction
                businesses face many challenges that halt progress and, at
                times, cause costly project delays. Tekrevol, a leader in
                construction software development, builds custom solutions that
                empower construction businesses to operate more efficiently and
                profitably—no matter the project scale.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Request a Quote
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
